<div class="document-preview">
  <div id="modalContainer" class="modal">
    <!-- Modal content -->
    <span class="modal-overlay-bg" id="modalOverlay"></span>
    <div class="modal-content modal-content-internals dynamic-component-content">
      <div class="dynamic-style">
        <ng-template #dynamic></ng-template>
      </div>
      <div class="gen-report-modal-ok-div">
        <gen-button
          class="gen-report-modal-button"
          id="closeEditReportModal"
          [text]="'OK'"
          [disabled]="!isDataChanged"
          (click)="updateReport()"></gen-button>
        <gen-button
          class="gen-report-modal-button"
          [type]="'quite'"
          [text]="'Cancel'"
          (click)="dismiss()"></gen-button>
      </div>
    </div>
  </div>
  <div class="report-div page-padding" [attr.contenteditable]="this.enableFreeStyleEdit != undefined && this.enableFreeStyleEdit && this.editingModeStatus " [ngClass]="{'extra-height': !!verticalLeftContainerPatientView, 'not-editable ': this.enableFreeStyleEdit != undefined && this.enableFreeStyleEdit && this.editingModeStatus}"  id="renderedReportDiv" #renderedReportDiv #renderedReportDivHTMLElement (click)="handleClick($event)"></div>
</div>
